module.exports = __webpack_public_path__ + "75e4dc5e2e8ac31a5f2bee6bbdd9b6d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/ir_30.jpg
// module id = 1707
// module chunks = 5